<template>
    <div class="welcome">
        <span>欢迎使用！{{name}}</span>
    </div>
</template>
<script>
import config from "@/config"

export default {
    data(){
        return {
            name:config.name
        }
    }
}
</script>

<style lang="less" scoped>
.welcome{
    float: left;
    line-height: 50px;
    padding: 0 10px;
    // box-shadow: 1px 2px 3px #ccc;
        // border-radius: 5px;
    span{
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        font-size: 20px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #999
    }
}
</style>


// WEBPACK FOOTER //
// src/components/main/components/welcome/welcome.vue